const SESSION_EXPIRED_MESSAGES = ['missing an ID Token', 'Cannot retrieve a new session']

export const isSessionExpiredError = (error) => {
  if (error?.code === 'NotAuthorizedException' || error?.name === 'NotAuthorizedException') {
    return true
  }

  return SESSION_EXPIRED_MESSAGES.some((text) => (error?.message || '').includes(text))
}
